import { IconButton, Heading, Text, HStack } from '@genial/components';
import { Spacing, Color, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React from 'react';

import { VisitLegacyPage } from '../../../../components/VisitLegacyPage';
import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';

interface HeaderProps {
  title: string;
}

export const Header: React.FC<HeaderProps> = ({ title }) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const onTransactionLegacyPress = () =>
    navigate({
      name: 'AngularFrame_TransactionFlow',
      params: { state: 'app.movimentacoes.deHoje' },
    });

  const goBack = () => {
    navigate('Cockpit');
  };

  if (isMobile) {
    return (
      <HStack alignItems="center" justifyContent={'space-between'}>
        <HStack alignItems="center" space={Spacing['inline.xxxs']}>
          <IconButton
            testId="icon"
            icon="ArrowLeft"
            iconSize="xxs"
            p={0}
            backgroundColor="transparent"
            iconColor={Color['brand.primary.principal']}
            onPress={goBack}
          />
          <Text variant="bold" fontSize={Typography['fontsize.lg']} color="neutral.black">
            Fluxo de Movimentações
          </Text>
        </HStack>
        <VisitLegacyPage onPress={onTransactionLegacyPress} />
      </HStack>
    );
  }

  return (
    <HStack alignItems="center" justifyContent="space-between">
      <HStack alignItems="center" space={Spacing['inline.xxxs']}>
        <IconButton
          icon="ArrowLeft"
          testId="return-button"
          shadow={3}
          variant="link"
          onPress={goBack}
          iconColor={Color['brand.tertiary.principal']}
          iconSize="xs"
        />
        <Heading testId="qa" size="h2">
          {title}
        </Heading>
      </HStack>
      <VisitLegacyPage onPress={onTransactionLegacyPress} />
    </HStack>
  );
};
